import BookingActionsSteps from "./checkout/actions/actions-steps";
import bookingDataStorage from "./data-storage";

const modBookingDataStorage = new bookingDataStorage();

export default class bookingSteps{
    
    private form: HTMLFormElement | null;
    private steps!: NodeListOf<Element>;
    private count: number = 0;
    private currentStep: number = 0;
    private bookingActions!: BookingActionsSteps;
    private prevButtonEl: HTMLButtonElement | null = null;
    private nextButtonEl: HTMLButtonElement | null = null;
    private btnPaymentEl: HTMLButtonElement | null = null;
    private bookingPaymentEl: HTMLDivElement | null = null;

    /**
     * Constructor
     * @param elForm - Selector for the form element
     * @param elSteps - Selector for the step elements
     * @param prevButton - Selector for the previous button
     * @param nextButton - Selector for the next button
     * @param btnPayment - Selector for the payment button
     */
    constructor(
        private elForm: string,
        private elSteps: string,
        private prevButton: string,
        private nextButton: string,
        private btnPayment: string,
        private bookingPayment: string
    ){
        
        this.form = document.querySelector(this.elForm);

        if(!this.form){
            
            return;

        }

        this.steps = this.form.querySelectorAll(this.elSteps);
        
        if(this.steps.length === 0){
            
            return;

        }

        this.count = this.steps.length;
        
        this.currentStep = 0;

        this.bookingActions = new BookingActionsSteps(
            this.elForm,
            this.prevButton,
            this.nextButton
        );

        this.prevButtonEl = document.querySelector(this.prevButton);
        this.nextButtonEl = document.querySelector(this.nextButton);
        this.btnPaymentEl = document.querySelector(btnPayment);
        this.bookingPaymentEl = document.querySelector(this.bookingPayment);

        if(!this.prevButtonEl || !this.nextButtonEl || !this.btnPayment || !this.bookingPaymentEl){
            
            return;

        }

        this.initEventListeners();

    }

    /**
     * Initialize event listeners for navigation buttons
     */
    private initEventListeners(): void{

        const check_step = modBookingDataStorage.getStorageStep();

        if(check_step){
            
            this.goLastStep();

        }

        this.nextButtonEl?.addEventListener("click", (e) => this.handleNextClick(e));
        this.prevButtonEl?.addEventListener("click", (e) => this.handlePrevClick(e));

    }

    /**
     * Go to the last step
     */
    private async goLastStep(): Promise<void>{
        
        const check_step = modBookingDataStorage.getStorageStep();

        if(check_step){
            
            this.nextButtonEl?.classList.add("hidden");
            
            const actionAllowed = await this.bookingActions.getAction(2);

            if(actionAllowed){
                
                this.updateStepClasses(this.currentStep, "close");
                this.updateStepClasses(check_step, "open");
                this.goToStep(this.steps[check_step]);

            }

        }

    }

    /**
     * Handle click event on the "Next" button
     * @param event - Click event
     */
    private async handleNextClick(event: Event): Promise<void>{
        
        event.preventDefault();

        if(!this.nextButtonEl || !this.prevButtonEl) return;
        
        const check_step = modBookingDataStorage.getStorageStep();

        if(check_step){
            
            this.currentStep = check_step;

        }

        try{
            
            const actionAllowed = await this.bookingActions.getAction(this.currentStep);

            if(actionAllowed){
                
                this.updateStepClasses(this.currentStep, "close");
                this.currentStep++;
                this.updateStepClasses(this.currentStep, "open");

                this.prevButtonEl.disabled = false;

                this.goToStep(this.steps[this.currentStep]);

                this.nextButtonEl.disabled = this.currentStep === this.count - 1;

            }

        }catch(error){
            
            // console.error("Error advancing to the next step:", error);

        }

    }

    /**
     * Handle click event on the "Previous" button
     * @param event - Click event
     */
    private handlePrevClick(event: Event): void{
        
        event.preventDefault();

        if(!this.prevButtonEl || !this.nextButtonEl) return;
        
        modBookingDataStorage.removeStorageStep();
        this.btnPaymentEl?.classList.add("hidden");
        this.bookingPaymentEl?.classList.add("hidden");

        this.updateStepClasses(this.currentStep, "close");
        this.currentStep--;
        this.updateStepClasses(this.currentStep, "open");

        this.prevButtonEl.disabled = this.currentStep === 0;
        this.nextButtonEl.disabled = false;

        this.goToStep(this.steps[this.currentStep]);

    }

    /**
     * Updates the class of the step elements to show or hide them
     * @param stepIndex - Index of the step to update
     * @param action - "open" to show step, "close" to hide step
     */
    private updateStepClasses(stepIndex: number, action: "open" | "close"): void{
        
        const step = this.steps[stepIndex];

        if(action === "open"){
            
            step.classList.add("step-booking-open");
            step.classList.remove("step-booking-close");

        }else{
            
            step.classList.add("step-booking-close");
            step.classList.remove("step-booking-open");

        }

    }

    /**
     * Scroll to the currently active step
     * @param element - Step element to scroll to
     * @param yOffset - Offset from the top of the screen (default: -100)
     */
    private goToStep(element: Element, yOffset: number = -100): void{
        
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });

    }

}
